export enum TernaryFilterOption {
  INCLUDE = "INCLUDE",
  REJECT = "REJECT",
  DISREGARD = "DISREGARD",
}



// WEBPACK FOOTER //
// ./src/types/TernaryFilterState.tsx